import styled from 'styled-components';
import { Button, Input, Layout } from 'antd';
import { createElement, ChangeEvent, Component, KeyboardEvent, MouseEvent, Props as ReactProps } from 'react';

import { DependencyProps } from '../../core/dependency';
import { LocationProps } from '../../core/location';
import { StateProps } from '../../core/state';

import applyGlobalStyles from '../../applyGlobalStyles';
import Store from "../../entity/store";

type Props = ReactProps<HTMLElement> & DependencyProps & StateProps & LocationProps;
type State = {
  email: string;
  password: string;
};

const { Content } = Layout;

const StyledLayout = styled(Layout)`
  width: 100%;
  height: 100%;
`;

const StyledContent = styled(Content)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledInput = styled(Input)`
  margin-bottom: 16px;
  max-width: 400px;
`;

const StyledButton = styled(Button)`
  max-width: 400px;
`;

const StyledOtherContainer = styled.div`
  padding-top: 20px;
  text-align: left;
  max-width: 400px;
  width: 100%;
`;

class SigninRoute extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      email: '',
      password: '',
    };

    this.onKeyPress = this.onKeyPress.bind(this);
    this.onClickSignInButton = this.onClickSignInButton.bind(this);
  }

  private onKeyPress(e: KeyboardEvent<HTMLInputElement>) {
    const enterKey = 'Enter';
    const store = this.props.state.currentStore as Store;
    if (e.key === enterKey) {
      this.props.dependency.authentication.signIn(this.state.email, this.state.password);
      window.location.href = store.topUri;
    }
  };

  private async onClickSignInButton(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();

    const store = this.props.state.currentStore as Store;
    await this.props.dependency.authentication.signIn(this.state.email, this.state.password);
    window.location.href = store.topUri;
  };

  public render() {
    const { currentStore } = this.props.state;
    return (
      <StyledLayout>
        <StyledContent>
          <StyledInput
            placeholder="メールアドレスを入力してください"
            onPressEnter={this.onKeyPress}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ email: e.target.value })}
          />
          <StyledInput
            placeholder="パスワードを入力してください"
            onPressEnter={this.onKeyPress}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ password: e.target.value })}
            type="password"
          />
          <StyledButton type="primary" block={true} onClick={(e: any) => this.onClickSignInButton(e)}>
            ログイン
          </StyledButton>
          <StyledOtherContainer>
            <a href={currentStore && currentStore.inviteUri || ''} >
              新規登録
            </a>
          </StyledOtherContainer>
          {/*<StyledOtherContainer>*/}
            {/*<a href={currentStore && currentStore.resetPasswordUri || ''} >*/}
              {/*パスワードを忘れた*/}
            {/*</a>*/}
          {/*</StyledOtherContainer>*/}
        </StyledContent>
        {applyGlobalStyles()}
      </StyledLayout>
    )
  }
}

export default SigninRoute;
